import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Mail, CheckCircle } from "lucide-react";
import bg from "../../../assets/img/spacia/web/Background.png";
import logo from "../../../assets/img/spacia/web/spacia_logo.png";

const SignupSuccess = () => {
  const history = useHistory();

  // Get the user's email from localStorage
  const userEmail = localStorage.getItem("pendingSignupEmail") || "your email";

  return (
    <div className="flex relative items-start w-full min-h-screen">
      {/* Background Image */}
      <div
        className="fixed inset-0 z-0 bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${bg})` }}
      ></div>

      {/* Logo */}
      <div className="absolute top-8 left-8 z-10">
        <Link to="/home">
          <img src={logo} alt="Spacia Logo" className="w-auto h-24" />
        </Link>
      </div>

      {/* Content Card */}
      <div className="relative z-10 p-6 mx-auto mt-20 mr-8 ml-auto w-full max-w-lg bg-white rounded-lg shadow-lg md:p-8 md:mt-32 md:mr-24 lg:mr-32">
        <div className="w-full">
          <header className="mb-4 text-center">
            <h1 className="mb-2 text-lg font-semibold md:text-xl">Signup Successful!</h1>
            <p className="text-sm text-gray-700">
              We've sent a confirmation email to <strong>{userEmail}</strong>
            </p>
          </header>

          {/* Progress Steps */}
          <div className="space-y-4 mb-6">
            <div className="relative">
              {/* Connecting line - stops at the last icon */}
              <div className="absolute w-0.5 bg-gray-200" style={{ left: "1rem", top: "1rem", height: "10rem" }}></div>

              {/* Step 1: Email Sent - Completed */}
              <div className="flex items-start space-x-3 relative mb-8">
                <div className="flex-shrink-0 w-8 h-8 bg-white rounded-full flex items-center justify-center relative z-10 border-2 border-green-600">
                  <CheckCircle className="w-5 h-5 text-green-600" />
                </div>
                <div className="flex-1 pt-1">
                  <p className="text-sm font-medium text-gray-900">Email Sent</p>
                  <p className="text-xs text-gray-500 mt-0.5">Confirmation email has been sent to your inbox</p>
                </div>
              </div>

              {/* Step 2: Check Your Email - Next */}
              <div className="flex items-start space-x-3 relative mb-8">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center border-2 border-blue-300 relative z-10">
                  <Mail className="w-4 h-4 text-blue-600" />
                </div>
                <div className="flex-1 pt-1">
                  <p className="text-sm font-medium text-gray-900">Check Your Email</p>
                  <p className="text-xs text-gray-600 mt-0.5">Open the email and click the confirmation link</p>
                </div>
              </div>

              {/* Step 3: Confirm Account - Pending/Disabled */}
              <div className="flex items-start space-x-3 opacity-60 relative">
                <div className="flex-shrink-0 w-8 h-8 bg-white rounded-full flex items-center justify-center border-2 border-gray-300 relative z-10">
                  <CheckCircle className="w-4 h-4 text-gray-400" />
                </div>
                <div className="flex-1 pt-1">
                  <p className="text-sm font-medium text-gray-700">Confirm Account</p>
                  <p className="text-xs text-gray-600 mt-0.5">Complete your account activation</p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-xs text-gray-500 text-center mb-6">
            Can't find the email? Check your spam folder or contact support
          </p>

          {/* Footer */}
          <button
            onClick={() => history.push("/signin")}
            className="w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md text-white font-medium bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mb-4"
          >
            Go to Sign In
          </button>

          <div className="text-center">
            <Link to="/signin" className="text-sm text-blue-600 hover:text-blue-800 hover:underline">
              Already confirmed? Sign in here
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;
